import { skedInboxApi } from "./_skedInboxApi";
import { Pagination, Message } from "types/conversationInbox";
import { CreateMessageAction } from "actions/conversationInbox";

interface getMessagesProps {
  conversationId: string;
  next?: string | null;
}

export async function getMessages({
  conversationId,
  next,
}: getMessagesProps): Promise<{
  data: Pagination<Message>;
}> {
  return await skedInboxApi.get("/messages", {
    params: {
      conversationId,
      sort: "createdAt:DESC",
      next,
    },
  });
}

export async function getMessage(id: string): Promise<{ data: Message }> {
  return await skedInboxApi.get(`/messages/${id}`);
}

export async function getMessagesBatch({
  requests,
}: {
  requests: getMessagesProps[];
}): Promise<{
  data: Array<Pagination<Message> & { conversationId: string }>;
}> {
  return await skedInboxApi.post("/messages/batch", {
    requests: requests.map((request) => ({
      conversationId: request.conversationId,
      next: request.next,
      sort: "createdAt:DESC",
    })),
  });
}

export async function createMessage({
  conversationId,
  text,
  isInternal,
  closeConversationAction,
  replyToId,
  attachments,
}: CreateMessageAction["payload"]): Promise<{
  data: Message;
}> {
  return await skedInboxApi.post("/messages", {
    conversationId,
    text,
    isInternal,
    closeConversation: !!closeConversationAction,
    replyToId,
    attachments,
  });
}

export async function setMessageDeletedStatus({
  id,
}: {
  id: string;
}): Promise<void> {
  await skedInboxApi.put(`/messages/${id}/deleted-status`, {});
}
export async function setMessageHidden({
  id,
  hidden,
}: {
  id: string;
  hidden: boolean;
}): Promise<void> {
  await skedInboxApi.put(`/messages/${id}/hidden-status`, {
    hidden,
  });
}

export async function setMessageSentiment({
  id,
  sentiment,
}: {
  id: string;
  sentiment: number;
}): Promise<{
  data: Message & { conversationSentimentType?: number };
}> {
  return await skedInboxApi.patch(`/messages/${id}/sentiment`, {
    sentiment,
  });
}

export async function setMessageText({
  id,
  text,
}: {
  id: string;
  text: string;
}): Promise<{
  data: Message;
}> {
  return await skedInboxApi.patch(`/messages/${id}/text`, {
    text,
  });
}
